export const colors = [
  "black",
  "light-black",
  "darkest-gray",
  "darker-gray",
  "dark-gray",
  "normal-gray",
  "light-gray",
  "lighter-gray",
  "lightest-gray",
  "darker-white",
  "white",
  "blue",
  "red",

  "prettylights-syntax-comment",
  "prettylights-syntax-constant",
  "prettylights-syntax-entity",
  "prettylights-syntax-storage-modifier-import",
  "prettylights-syntax-entity-tag",
  "prettylights-syntax-keyword",
  "prettylights-syntax-string",
  "prettylights-syntax-variable",
  "prettylights-syntax-brackethighlighter-unmatched",
  "prettylights-syntax-invalid-illegal-text",
  "prettylights-syntax-invalid-illegal-bg",
  "prettylights-syntax-carriage-return-text",
  "prettylights-syntax-carriage-return-bg",
  "prettylights-syntax-string-regexp",
  "prettylights-syntax-markup-list",
  "prettylights-syntax-markup-heading",
  "prettylights-syntax-markup-italic",
  "prettylights-syntax-markup-bold",
  "prettylights-syntax-markup-deleted-text",
  "prettylights-syntax-markup-deleted-bg",
  "prettylights-syntax-markup-inserted-text",
  "prettylights-syntax-markup-inserted-bg",
  "prettylights-syntax-markup-changed-text",
  "prettylights-syntax-markup-changed-bg",
  "prettylights-syntax-markup-ignored-text",
  "prettylights-syntax-markup-ignored-bg",
  "prettylights-syntax-meta-diff-range",
  "prettylights-syntax-brackethighlighter-angle",
  "prettylights-syntax-sublimelinter-gutter-mark",
  "prettylights-syntax-constant-other-reference-link",
  "fg-default",
  "fg-muted",
  "fg-subtle",
  "canvas-default",
  "canvas-subtle",
  "border-default",
  "border-muted",
  "neutral-muted",
  "accent-fg",
  "accent-emphasis",
  "attention-subtle",
  "danger-fg",
];
